import { BrowserRouter, Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import Home from './pages/Home';
import Outlet from './pages';
import Login from './pages/Login';
import Reward from './pages/Reward'
import Profile from './pages/Profile';
import { useEffect, useState } from 'react';
import { BASE, calculateDeliveryTime, distanceKm, getAddressFromLatLng, MAX_RADIUS_KM } from './utils/location';
import { setLocation } from './redux/slice/local';
import { useDispatch, useSelector } from 'react-redux';
import { formatCountdown, getNextOpeningDate, isRestaurantOpen } from './utils/other';
import { DATA } from './utils/data';
import axios from './axios';
import { clearUser, setUser } from './redux/slice/user';
import { auth, db_fire } from './firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import OrderDetails from './pages/OrderDetails';
import Coupon from './pages/Coupon';
import Item from './pages/Item';
import Order from './pages/Order';
import Guest from './pages/Guest';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import { trackVisit } from './utils/trackVisit';
import Customers from './pages/Customer';
import Delivery from './pages/Delivery';




function App() {
  const { userDetails } = useSelector(state => state.user)
  const dispatch = useDispatch()
 
  useEffect(() => {
    if (!userDetails?._id) return;

    const ref = doc(db_fire, "users", userDetails._id);

    const unsub = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        dispatch(setUser({ _id: snap.id, ...snap.data() }));
      }
    });

    return () => unsub();
  }, []);
 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("/");
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);
 
 

  function useCountdown(targetDate) {
    const [timeLeft, setTimeLeft] = useState(
      targetDate - new Date()
    );

    useEffect(() => {
      const interval = setInterval(() => {
        setTimeLeft(targetDate - new Date());
      }, 1000);

      return () => clearInterval(interval);
    }, [targetDate]);

    return formatCountdown(timeLeft);
  }
  const openNow = isRestaurantOpen(DATA.timings);
  const nextOpeningDate = getNextOpeningDate(DATA.timings);
  const countdown = useCountdown(nextOpeningDate);


  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={!userDetails.isLoggedIn ? <Login /> : <Outlet />}>
          <Route path='/' element={<Home />} />
          <Route path='/item' element={<Item />} />
          <Route path='/order' element={<Order />} />
          <Route path='/profile' element={userDetails.isLoggedIn ? <Profile /> : <Navigate to="/" replace />} />
          <Route path="/order/:id" element={!userDetails.isLoggedIn ? <Navigate to="/" replace /> : <OrderDetails />} />
          <Route path='/customer' element={<Customers />} />
          <Route path='/delivery' element={<Delivery />} />
          <Route path='/guest' element={<Guest />} />
          <Route path='/reward' element={<Reward />} />
          <Route path='/coupon' element={!userDetails.isLoggedIn ? <Navigate to="/" replace /> : <Coupon />} />
        </Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
    </BrowserRouter >
  );
}

export default App;


